

<div class="container">

    <div class="headings">
        <span class="hr"></span>
        <h1 class="text-center">Edit Governorates</h1>
        <span class="hr"></span>
    </div>

    <button class="btn btn-success add" routerLink="/addgov" > Add  </button>


    <table class="table">
        <thead class="thead-dark">
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
        </thead>
        <tbody *ngIf="listOfCategory">
            <tr *ngFor="let item of  listOfCategory">
                <td > {{item.id}} </td>
                <td > {{item.name}} </td>
                <td > <button class="btn btn-success"  (click)="edit(item.id,item)" > Edit </button> </td>
                <td > <button class="btn btn-danger"  (click)="delete(item.id)" > Delete </button> </td>
            </tr>  
        </tbody>
      </table>
      
</div>